import React from 'react';
import { Route } from 'react-router';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Footer, Header } from '../assets/styles/lp';
import bebancaLogo from '../assets/images/bebanca/logo-w.svg';

const LP = ({ page, siteName }) => (
  <section id="main" className="lp">
    <Header>
      <Link to="/">
        <img src={bebancaLogo} title="bebanca" alt="Bebanca" />
      </Link>
    </Header>
    <Route component={page} />
    <Footer>&copy; 2018 {siteName} - Todos os direitos Reservados.</Footer>
  </section>
);

LP.propTypes = {
  page: PropTypes.func.isRequired,
  siteName: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  siteClassName: `__${state.sites.data.name.toLowerCase()}`,
  siteName: state.sites.data.name,
});

export default connect(mapStateToProps)(LP);



// WEBPACK FOOTER //
// ./src/layouts/lp.js